import { Stack, Typography } from "@mui/material";

function TimelineHeader() {
    return (
        <Stack
            sx={{
                px: "1rem",
                gap: "1.5rem",
            }}
        >
            <Typography variant="h5">Linha do tempo</Typography>

            <Typography
                variant="body1"
                sx={{
                    color: "rgba(62, 55, 78, 0.60)",
                    fontFamily: "Noto Sans",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "1.25rem",
                    letterSpacing: "0.0088rem",
                }}
            >
                Selecione um perfil, defina a carga horária e mensure quantos
                recursos serão atribuídos.
            </Typography>
        </Stack>
    );
}

export default TimelineHeader;
